import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './system-message-constants';
import * as actions from './system-message-actions';

export function* fetchSystemMessage(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'messages',
      options: {
        errorMessage: 'Could not fetch system messages',
        retryAction: action,
      },
    });
    yield put(actions.systemMessagesSuccess(results));
  } catch (err) {
    yield put(actions.systemMessagesFailure(err));
  }
}

export function* unlockSystemMessage(action) {
  try {
    const { type, id, url } = action.payload;
    yield call(callApi, {
      endpoint: `info/unlock/${type}/${id}`,
      options: {
        method: 'POST',
        errorMessage: 'Could not unlock system mesasge',
        retryAction: action,
      },
    });
    yield put(actions.unlockSystemMessageSuccess(url));
  } catch (err) {
    yield put(actions.unlockSystemMessageFailure(err));
  }
}

export function* discardSystemMessage(action) {
  try {
    const { type, id } = action.payload;
    yield call(callApi, {
      endpoint: `info/discard/${type}/${id}`,
      options: {
        method: 'POST',
        errorMessage: 'Could not delete system message',
        retryAction: action,
      },
    });
    yield put(actions.discardSystemMessageSuccess());
  } catch (err) {
    yield put(actions.discardSystemMessageFailure(err));
  }
}

function* watchFetchSystemMessage() {
  yield takeLatest(
    [types.DISCARD_SYSTEM_MESSAGE_REQUEST, types.SYSTEM_MESSAGE_REQUEST],
    fetchSystemMessage,
  );
}

function* watchDiscardSystemMessage() {
  yield takeLatest(types.DISCARD_SYSTEM_MESSAGE_REQUEST, discardSystemMessage);
}

function* watchUnlockSystemMessage() {
  yield takeLatest(types.UNLOCK_SYSTEM_MESSAGE_REQUEST, unlockSystemMessage);
}

export default [
  fork(watchFetchSystemMessage),
  fork(watchDiscardSystemMessage),
  fork(watchUnlockSystemMessage),
];
